import { getColorByCategory, getColorByPercentage} from '@/utils/globals';
import React from 'react';

interface CircularProgressProps {
  segments?: number;
  progress: number;
  size?: number;
  strokeWidth?: number;
  gapAngle?: number;
  strokeColor?: string;
  backgroundColor?: string;
  children?: React.ReactNode;
  category: number;
}

const CircularProgress: React.FC<CircularProgressProps> = ({
  segments = 10,
  progress,
  size = 30,
  strokeWidth = 6,
  gapAngle = 1,
  backgroundColor = "#DFE4EA",
  category,
  children
}) => {
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const segmentAngle = 360 / segments;
  const currentProgress = Math.round(progress / (100 / segments));

  let computedStrokeColor = getColorByCategory(category);



  return (
    <div className="relative flex flex-row items-center" > 
    {/* style={{ width: size, height: size }} */}
      <div
      className='font-semibold text-lg'
      style={{color:getColorByCategory(category)}}>
        {progress}
      </div>
      <div className="absolute inset-0 flex items-center justify-center">
        {children}
      </div>
    </div>
  );
};

export default CircularProgress;


// <svg
// className="transform -rotate-90"
// width={size}
// height={size}
// viewBox={`0 0 ${size} ${size}`}
// >
// {/* Draw background segments */}
// {Array.from({ length: segments }).map((_, index) => (
//   <circle
//     key={`bg-${index}`}
//     cx={size / 2}
//     cy={size / 2}
//     r={radius}
//     fill="none"
//     stroke={backgroundColor}
//     strokeWidth={strokeWidth}
//     strokeDasharray={`${(circumference / segments) - gapAngle} ${circumference}`}
//     strokeDashoffset={0}
//     strokeLinecap="round"
//     transform={`rotate(${index * segmentAngle} ${size / 2} ${size / 2})`}
//   />
// ))}

// {/* Draw progress segments */}
// {Array.from({ length: currentProgress }).map((_, index) => (
//   <circle
//     key={`progress-${index}`}
//     cx={size / 2}
//     cy={size / 2}
//     r={radius}
//     fill="none"
//     stroke={computedStrokeColor}
//     strokeWidth={strokeWidth}
//     strokeDasharray={`${(circumference / segments) - gapAngle} ${circumference}`}
//     strokeDashoffset={0}
//     strokeLinecap="round"
//     transform={`rotate(${index * segmentAngle} ${size / 2} ${size / 2})`}
//   />
// ))}
// </svg>